import { UseMutationResult, useMutation } from 'react-query';
import { PershingSsoService } from '../../services/wealthlane-identity-services';
import { Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto } from '../../services/wealthlane-identity-services/models/Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto';

const usePostCheckPershingSsoEligibility = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess?: (data?: Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto) => void
): UseMutationResult<
  Wealthlane_Dtos_SsoProvider_PershingSsoEligibilityResponseDto | undefined,
  unknown,
  string,
  unknown
> => {
  return useMutation(
    async (participantId: string) => {
      const response = await handleRequest(
        PershingSsoService.postApiIdentityApiAppPershingSsoCheckEligibility()
      );
      return response;
    },
    {
      onSuccess: (data) => {
        onSuccess?.(data);
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCheckPershingSsoEligibility;
